import React from 'react';
import { cn } from '@/lib/utils';

export interface PageHeaderProps {
  title: string;
  subtitle?: string;
  /** Optional class for the title (e.g. font-medium to match section headings) */
  titleClassName?: string;
  /** Inline meta row (e.g. status row, baseline banner) rendered below title */
  meta?: React.ReactNode;
  /** Right-aligned actions (e.g. buttons, links) */
  actions?: React.ReactNode;
  className?: string;
}

/**
 * Single per-page header: title, optional subtitle, optional right actions, optional meta row.
 * Console-density: compact, tight spacing.
 */
export const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  subtitle,
  titleClassName,
  meta,
  actions,
  className,
}) => {
  return (
    <div className={cn('pb-2', className)}>
      <div className="flex items-center justify-between gap-4">
        <div className="flex items-baseline gap-2 min-w-0">
          <h1 className={cn('text-sm font-semibold tracking-tight text-foreground truncate', titleClassName)}>
            {title}
          </h1>
          {subtitle != null && subtitle !== '' && (
            <span className="text-xs text-muted-foreground truncate hidden sm:inline">
              {subtitle}
            </span>
          )}
        </div>
        {actions != null && (
          <div className="flex items-center gap-2 shrink-0">
            {actions}
          </div>
        )}
      </div>
      {meta != null && <div className="mt-1.5">{meta}</div>}
    </div>
  );
};

export default PageHeader;
